import axios from 'axios';

export default {
  loadParkAccessibilities () {
    return new Promise(resolve => {
      axios.get(`https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/ParksAccessibility.json?&timestamp=${new Date().getTime()}`).then((result) => {
        let data = result.data
        data.map(r => {
          r.lat = parseFloat(r.Lat)
          r.lng = parseFloat(r.Lng)

          r.parking = false;
          if (r['Parking Access']) {
            r.parking = r['Parking Access'].toLowerCase().includes('accessible spots') || r['Parking Access'].toLowerCase().includes('garage')
          }

          r.restroom = false;
          if (r['Restroom Access']) {
            r.restroom = !r['Restroom Access'].toLowerCase().includes('no restroom on site')
          }

          r.playgroundequip = false;
          if (r['accessible playground equip.']) {
            r.playgroundequip = !r['accessible playground equip.'].toLowerCase().includes('none')
          }

          r.seats = false;
          if (r['seating']) {
            r.seats = r['seating'].toLowerCase() !== 'none'
          }

          r.freshwater = false;
          if (r['Fresh Water on Site'] && r['Fresh Water on Site'].toLowerCase() === 'stream/pond on site') {
            r['Fresh Water on Site'] = 'Access to Pond/Stream'
          }
          if (r['Fresh Water on Site'] && r['Fresh Water on Site'].toLowerCase() === 'no access to stream/pond') {
            r['Fresh Water on Site'] = 'No access to Pond/Stream'
          }

          r.playarea = false;
          if (r['Play Area on Site']) {
            r.playarea = r['Play Area on Site'].toLowerCase() === 'yes'
          }

          // change shade covers to sun cover
          if (r['Access to Sun Cover'] === 'no shade cover') {
            r['Access to Sun Cover'] = 'no sun cover';
          }

          // changes to Play/Park Access
          if (r['Play/Park Access'] === 'ramp/zero dimension and stair access') {
            r['Play/Park Access'] = 'ramp and stair access';
          }
        })
        resolve(data);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/parksAccessibility/parksAccessibility.service.js